import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../../config';
import { useSelector } from 'react-redux';
import '../../products/form/productForm.scss';   // styles des champs (.form-controle/.form-input)
import { NdoePage, NdoePageHeader, NdoeFormSection, NdoeActionButton } from '../../../components/ndoe';

const LivraisonForm = () => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
  const [data, setData] = useState({})
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const userId = useSelector((state) => state.user?.currentUser?.id)

  const handleInputChange = (e) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    setData((prev) => ({ ...prev, [fieldName]: fieldValue }));
  };

  const handleClick = async (e) => {
    e.preventDefault();

    try{
      setIsSaving(true);
      await axios.post(`${DOMAIN}/api/livraison`, { ...data, user_cr: userId })
      Swal.fire({
        title: 'Success',
        text: 'Livraison créée avec succès!',
        icon: 'success',
        confirmButtonText: 'OK',
      });
      navigate('/livraison')   // la liste se recharge à l'arrivée (plus de window.location.reload)
    }catch(err) {
      Swal.fire({
        title: 'Error',
        text: err.message,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }finally{
      setIsSaving(false);
    }
  }

  return (
    <NdoePage>
      <div className="clientForm">
        <NdoePageHeader eyebrow="Logistique" title="Créer une livraison" subtitle="Enregistrer une nouvelle date de livraison" />

        <NdoeFormSection step={1} title="Livraison" collapsible={false}>
          <div className="form-controle">
            <label>Date de livraison</label>
            <input type="date" name='date_livre' className="form-input" value={data?.date_livre ?? ''} onChange={handleInputChange} />
          </div>
        </NdoeFormSection>

        <div className="ndoe-sticky-cta">
          <NdoeActionButton variant="secondary" onClick={() => navigate('/livraison')}>Annuler</NdoeActionButton>
          <NdoeActionButton variant="primary" onClick={handleClick} loading={isSaving}>Soumettre</NdoeActionButton>
        </div>
      </div>
    </NdoePage>
  )
}

export default LivraisonForm
